import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/../public/img/TemplateData/ichijo-logo.png'
import _imports_1 from '@/assets/img/info/enter_btn.png'
import _imports_2 from '@/assets/img/park/joe_pavilion.png'
import _imports_3 from '@/assets/img/info/close_btn.png'
import _imports_4 from '@/assets/img/info/joe_pose1.png'
import _imports_5 from '@/assets/img/park/present_02.png'
import _imports_6 from '@/assets/img/tap_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-f0b9d53a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "unityContainer",
  id: "unity-container"
}
const _hoisted_2 = {
  ref: "unityCanvas",
  id: "unity-canvas"
}
const _hoisted_3 = {
  ref: "unityLoadingBar",
  id: "unity-loading-bar"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "visible-logo" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "unity-progress-bar-empty" }, [
    /*#__PURE__*/_createElementVNode("div", { id: "unity-progress-bar-full" })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "unity-warning" }, null, -1))
const _hoisted_7 = {
  ref: "pavillionName",
  class: "title"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, null, -1))
const _hoisted_9 = {
  ref: "pavillionUrl",
  class: "link"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  ref: "pavillionIcon",
  class: "room"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "joe" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" トロフィーを0個獲得したよ！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("本物のジョー君帽子に"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("応募しよう！ ")
], -1))
const _hoisted_18 = {
  ref: "presentUrl",
  class: "link"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_park_header = _resolveComponent("park-header")!
  const _component_campaign = _resolveComponent("campaign")!
  const _component_notice = _resolveComponent("notice")!
  const _component_chara_control = _resolveComponent("chara-control")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_park_header, {
      isGlobalMenu: _ctx.isGlobalMenu,
      ref: "parkHeader",
      onToggleSound: _ctx.toggleSound
    }, null, 8, ["isGlobalMenu", "onToggleSound"]), [
      [_vShow, _ctx.isLoaded]
    ]),
    _createElementVNode("canvas", _hoisted_2, null, 512),
    _createElementVNode("div", _hoisted_3, _hoisted_5, 512),
    _hoisted_6,
    _createElementVNode("div", {
      ref: "pavillionContainer",
      class: "pavillion-container",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hidePavillion && _ctx.hidePavillion(...args)))
    }, [
      _createElementVNode("div", {
        class: "pavillion",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("h1", _hoisted_7, null, 512),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enterPavillion && _ctx.enterPavillion(...args)))
          }, _hoisted_11)
        ], 512),
        _createElementVNode("div", _hoisted_12, null, 512),
        _hoisted_13
      ]),
      _createElementVNode("button", {
        class: "back",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hidePavillion && _ctx.hidePavillion(...args)))
      }, _hoisted_15)
    ], 512),
    _createElementVNode("div", {
      ref: "presentContainer",
      class: "present-container",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.hidePresent && _ctx.hidePresent(...args)))
    }, [
      _hoisted_16,
      _createElementVNode("div", {
        class: "present",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enterPresent && _ctx.enterPresent(...args)))
          }, _hoisted_20)
        ], 512)
      ]),
      _createElementVNode("button", {
        class: "back",
        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hidePresent && _ctx.hidePresent(...args)), ["stop"]))
      }, _hoisted_22)
    ], 512),
    _createVNode(_component_campaign),
    _createVNode(_component_notice),
    _createElementVNode("div", {
      ref: "cover",
      class: "cover",
      onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tap && _ctx.tap(...args)), ["stop"]))
    }, [
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tap && _ctx.tap(...args)), ["stop"]))
      }, _hoisted_24)
    ], 512),
    _withDirectives(_createVNode(_component_chara_control, null, null, 512), [
      [_vShow, false]
    ])
  ], 512)), [
    [_vShow, _ctx.isShow]
  ])
}